/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
// styles
import "./InviteFriends.scss";
//data

// assets

import icon_copy from "../../assets/icons/icon-copy.svg";

import History from "./History";
import { showSuccessMessage, showErrorMessage } from "../../utils/notification";
import Loader from "react-loader-spinner";
import SocialTabs from "./SocialTabs";
import { useInvitationContext } from "../../context/providers/InvitationContext";
export default function InviteFriends(props) {
	const [shareInputValue] = useState(`${process.env.REACT_APP_ACADEMY_SERVER}/cc`);
	const userAuthenticated = JSON.parse(localStorage.getItem("user"));

	const { invitations, referreds, code, error, getInvitations, clearNotification, success } = useInvitationContext();
	React.useEffect(() => {
		getInvitations();
		if (success !== null) {
			showSuccessMessage(success);
			clearNotification();
		}
		if (error !== null) {
			showErrorMessage(error);
			clearNotification();
		}
	}, [success, error]);

	return (
		<div className="invite__container container container--main d-flex flex-column d-xl-block">
			<div className="container--content">
				<div className="container--default mt-4 p-3 mt-xl-0">
					<h1 className="container__title pt-1 pt-md-2">Share with your friends!</h1>
					<p className="mt-2 mt-md-3">					
						Share my website with your friends. They will receive a 20% discount on their first purchase and you will receive
						20% discount on your next purchase.
					</p>

					{userAuthenticated !== null && code !== null ? (
						<SocialTabs user={userAuthenticated} code={code} />
					) : (
						<div
							className=" flex-grow-1 w-100 mt-2"
							style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "2rem" }}
						>
							<Loader type="TailSpin" color="#3326ae" height={50} width={50} style={{ marginTop: "3%" }} />
							<p className="input__label mt-3 " style={{ marginLeft: "15px" }}>
								Loading
							</p>
						</div>
					)}
				</div>
				<div className="container--default mt-4 p-3">
					<h2 className="container__title pt-1 pt-md-2">Share this link</h2>
					<div className="input__group invite__share-input mt-2">
						{code !== null ? (
							<>
								<input
									type="text"
									className="input input--primary"
									defaultValue={`${shareInputValue}/${code}`}
									disabled
								/>
								<CopyToClipboard
									text={`${shareInputValue}/${code}`}
									onCopy={() => {
										//throw new Error('Opps je le fais expres')
										console.log(`copied! ${shareInputValue}`);
										showSuccessMessage(`link copied ! ${shareInputValue}/${code}`);
									}}
								>
									<button className="btn btn--primary_light">
										<img src={icon_copy} alt="" />
									</button>
								</CopyToClipboard>
							</>
						) : (
							<Loader
								type="TailSpin"
								color="#3326ae"
								height={30}
								width={30}
								style={{ marginTop: "3%", marginLeft: "45%" }}
							/>
						)}
					</div>
				</div>
			</div>
			<div className="d-flex order-first">
				<div className="container--default text-center flex-grow-1 p-3 d-md-flex justify-content-between align-items-center px-md-4">
					<span className="d-block fw--500">Invitations sent</span>
					<span className="d-block line_height--reset fz--24 fw--600 color--primary mt-2 mt-md-auto py-md-1">
						{invitations !== null ? (
							`${invitations.length}`
						) : (
							<Loader type="TailSpin" color="#3326ae" height={30} width={30} style={{ marginTop: "3%" }} />
						)}
					</span>
				</div>

				<div className="container--default text-center flex-grow-1 p-3 ml-4 d-md-flex justify-content-between align-items-center px-md-4">
					<span className="d-block fw--500">Invitations used</span>
					<span className="d-block line_height--reset fz--24 fw--600 color--accent mt-2 mt-md-auto py-md-1">
						{referreds !== null ? (
							`${referreds.length}`
						) : (
							<Loader type="TailSpin" color="#3326ae" height={30} width={30} style={{ marginTop: "3%" }} />
						)}
					</span>
				</div>
			</div>

			<div className="container--default mt-4 p-3">
				<h2 className="container__title pt-1 pt-md-2">Historical</h2>
				<div className="table__container pt-2 pt-md-4">
					{invitations !== null || referreds !== null ? (
						<>
							{invitations.length > 0 && invitations.map((item, index) => <History key={index} item={item} />)}
							{referreds.length > 0 && referreds.map((item, index) => <History key={index} item={item} />)}
						</>
					) : (
						<div
							className=" flex-grow-1 w-100 mt-2"
							style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "2rem" }}
						>
							<Loader type="TailSpin" color="#3326ae" height={50} width={50} style={{ marginTop: "3%" }} />
							<p className="input__label mt-3 " style={{ marginLeft: "15px" }}>
								Please wait
							</p>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}
